import { useState, useEffect } from "react";
import axios from "axios";
import { Container, Table, Button, Spinner } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import ModalCrud from "./Modal";
import { DoLogout, provinces } from "../Utils";
import Pagination from "../Pagination/Pagination";

export default function DojosClassesList() {
  let params = useParams();
  const dojoId = params.id;

  const history = useHistory();

  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");

  const PAGE_SIZE = 5;
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({});

  const [isLoading, setLoading] = useState(false);

  const [detail, setDetail] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [classes, setClasses] = useState([]);
  const [classDetail, setClassDetail] = useState(null);

  const token = JSON.parse(ls.get("jwt"));
  const usuario = JSON.parse(ls.get("userData"));

  useEffect(() => {
    BuildBase();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    GetClasses(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const BuildBase = async () => {
    setLoading(true);

    if (!dojoId) DoLogout();

    const detail = await axios
      .get(
        `${API_URL}/dojos?filters[id][$eq]=${dojoId}&populate=horarios,responsible,administrative&filters[$or][0][responsible][id][$eq]=${usuario.id}&filters[$or][1][administrative][id][$eq]=${usuario.id}`,
        headerRequest
      )
      .catch((error) => {
        if (error.response.status === 401) DoLogout();
      });
    console.log({ detail });
    if (detail?.data?.data?.length < 1) {
      DoLogout();
      setLoading(false);
      return;
    }

    setDetail(detail.data.data[0]);

    GetClasses(1);
  };

  const GetClasses = async (page) => {
    const classesData = await axios
      .get(
        `${API_URL}/classes?sort[0]=day%3Adesc&sort[1]=time%3Adesc&pagination[page]=${
          page ? page : 1
        }&pagination[pageSize]=${PAGE_SIZE}&pagination[withCount]=true&populate=instructor,alumnos&filters[dojo][id][$eq]=${dojoId}`,
        headerRequest
      )
      .then((classes) => {
        setPagination(classes.data.meta.pagination);
        return classes.data.data;
      });
    setClasses(classesData);
    setLoading(false);
  };

  const DataDelete = (e) => {
    setLoading(true);
    axios.delete(`${API_URL}/classes/${e.id}`, headerRequest).catch((error) => {
      if (error.response.status === 401) DoLogout();
    });
    BuildBase();
  };

  const DataEdit = (e) => {
    setClassDetail(e);
    setShowModal(true);
  };

  const renderData = (
    <>
      <Table striped hover size="sm" responsive="sm">
        <thead>
          <tr>
            <th>Dia/Hora</th>
            <th>Instructor</th>
            <th>
              <Button
                size="sm"
                variant="success"
                onClick={() => DataEdit(null)}
              >
                CREAR
              </Button>
            </th>
          </tr>
        </thead>
        <tbody>
          {classes.length < 1 ? (
            <tr>
              <td colSpan="6" align="center">
                No hay datos.
              </td>
            </tr>
          ) : (
            classes.map((e) => (
              <tr id={e.id} key={e.id}>
                <td align="left">
                  {e.attributes.day} {e.attributes.time.replace(":00.000", "")}
                </td>
                <td align="left">
                  {e.attributes.instructor?.data.attributes.name}{" "}
                  {e.attributes.instructor?.data.attributes.lastname}
                </td>
                <td align="center" className="w140">
                  <>
                    <Button
                      size="sm"
                      className="me-2"
                      onClick={() => DataEdit(e)}
                      variant="warning"
                    >
                      Editar
                    </Button>
                    <Button
                      size="sm"
                      onClick={() => DataDelete(e)}
                      variant="danger"
                    >
                      Borrar
                    </Button>
                  </>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
      <Pagination
        className="pagination-bar"
        currentPage={currentPage}
        totalCount={pagination.total}
        pageSize={PAGE_SIZE}
        onPageChange={(page) => setCurrentPage(page)}
      />
    </>
  );

  return (
    <Container className="p-3 mb-4 bg-light rounded-3" fluid="lg">
      <p style={{ textAlign: "left" }}>
        <Button size="sm" variant="primary" onClick={history.goBack}>
          VOLVER
        </Button>
      </p>
      <h4>CLASES</h4>
      {detail ? (
        <p>
          Dojo: <b>{detail.attributes.name}</b>, {detail.attributes.address},{" "}
          {provinces[detail.attributes.province]}
          {/*
          <br />
          Horarios:
          {detail.attributes.horarios.map((e) => (
            <b>
              {e.weekday} {e.hora.replace(":00.000", "")}
            </b>
          ))}
           */}
        </p>
      ) : null}
      {isLoading ? <Spinner animation="border" /> : renderData}
      {showModal && (
        <div
          onClick={() => setShowModal(false)}
          className="modal-background"
        ></div>
      )}
      {showModal && (
        <ModalCrud
          show={showModal}
          dojodetail={detail}
          dojoclass={classDetail}
          onHide={(saved) => {
            setShowModal(false);
            if (saved === true) GetClasses(currentPage);
          }}
        />
      )}
    </Container>
  );
}
